import axios from "axios";

const API = "https://data.shreemwell.in/api/company";

const getConfig = () => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const getCompanies = () => axios.get(API, getConfig());

export const createCompany = (data) =>
  axios.post(`${API}/add`, data, getConfig());

export const updateCompany = (id, data) =>
  axios.put(`${API}/update/${id}`, data, getConfig());

export const deleteCompany = (id) =>
  axios.delete(`${API}/delete/${id}`, getConfig());

export const getCompany = (id) =>
  axios.get(`${API}/${id}`, getConfig());